import React, {useState } from 'react';

import api from './services/api';

import FormInput from './FormInput'
import PageTitle from './PageTitle'
import PageSubtitle from './PageSubtitle'
import ButtonHover from './ButtonHover'
import FormSelect from './FormSelect'


export default function Signup (props){

const[email, setEmail] = useState("");
const[userType, setUserType] = useState("")
const[password1, setPassword1] = useState("")
const[password2, setPassword2] = useState("")
const[errorEmail, setErrorEmail] = useState("")
const[errorUserType, setErrorUserType] = useState("")
const[errorPassword1, setErrorPassword1] = useState("")
const[errorPassword2, setErrorPassword2] = useState("")
const[errorPasswordLength, setErrorPasswordLength] = useState("")
const[errorPasswordMatch, setErrorPasswordMatch] = useState("")
const[errorMessage, setErrorMessage] = useState("")
const[showErrors, setShowErrors] = useState(false)
const[hover, setHover] = useState(false)

const handleSubmitUser = async(e) => {
  e.preventDefault();

  let validationUserType = (!userType)
    ? setErrorUserType("* Please enter username")
    : setErrorUserType("")

  let validationEmail = (!email)
    ? setErrorEmail("* Please enter email")
    : setErrorEmail("")

  let validationPassword = (!password1)
    ? setErrorPassword1("* Please enter password")
    : setErrorPassword1("")

  let validationPassword2 = (!password2)
    ? setErrorPassword2("* Please enter password confirmation")
    : setErrorPassword2("")

  let validationPasswordLength = (password1.length < 6)
    ? setErrorPasswordLength("* Password must have at least 6 characters")
    : setErrorPasswordLength("")

  let validationPasswordMatch = (password1 !== password2)
    ? setErrorPasswordMatch("* Passwords do not match")
    : setErrorPasswordMatch("")

  if (
      !userType 
      || !email 
      || !password1 
      || !password2 
      || password1.length < 6 
      || password1 !== password2
      ) {


    setShowErrors(true)

  } else {


    try {
 
      const response = await api.post("/user", {
        userType,
        email,
        password1,
        password2,
      });

      // Get a JWT back
      const data = await response.data
      console.log(data)

      if (data.message) {
        setErrorMessage(data.message)
      } else {

        //Store JWT in localStorage so user is authenticated
        localStorage.setItem("@Researchsynthase", data.token);

        if(userType === 'resident'){
          return window.location = "/projectform";
        } else if (userType === 'prephysician'){
          return window.location = '/prephysicianform'
        } else {
          return window.location = '/'
        }
                 
      }

    } catch (err) {
      console.error(err.message)
    }
  }

}

  let buttonStyleFalse = {
    border: '1px solid #FFF',
    color: '#FFF',
    borderRadius: '5px',
    background: "#80a3db",
    margin: '5px',
    padding: '7px 20px',
    cursor: 'pointer',
    fontSize: '20px',
    textAlign: 'center',
  }

  let buttonStyleTrue = {
    border: '1px solid #FFF',
    color: '#80a3db',
    borderRadius: '5px',
    background: '#FFF',
    margin: '5px',
    padding: '7px 20px',
    cursor: 'pointer',
    fontSize: '20px',
    textAlign: 'center',
  }

let warnStyle ={
  fontSize: '17px',
  margin: '3px 0 0 0',
  fontFamily: 'Montserrat',
  fontWeight: '600',
  color: 'white',
}

    return(
      <div>
        <div style={{display: 'flex'}}>
          <div style={{width: '7vw'}}>
          </div>
          <div style={{width: '86vw'}}>
            <div style={{height: '50px'}}></div>
            <PageTitle
              pageTitle = 'Publications, here we come!'
              />
            <PageSubtitle
              pageSubtitle = 'Get started by filling out the information below'
              />
            <form onSubmit={handleSubmitUser}>
              <FormInput
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder='What is your email?'
                autoFocus
                />
              <FormSelect
                hook={userType}
                setHook={setUserType}
                selectOptions={[
                  {title: 'What is your level of training?', value: ''},
                  {title: 'Resident or attending physician', value: 'resident'},
                  {title: 'Medical or premedical student', value: 'prephysician'}
                ]}
                />
              <FormInput
                value={password1}
                onChange={e => setPassword1(e.target.value)}
                placeholder="Password"
                />
              <FormInput
                value={password2}
                onChange={e => setPassword2(e.target.value)}
                placeholder='Confirm password'
                />
              <div style={{
                  display: 'flex',
                  justifyContent: 'center'
                }}>
                <div
                  style={{
                    width:'600px',
                    padding: '10px',
                    margin: '0px',
                    }}
                  >
                  {(errorMessage !== "")
                      ? <p style={warnStyle}>{errorMessage}</p>
                      : null
                  }
                  {(errorEmail !== "")
                    ? <p style={warnStyle}>{errorEmail}</p>
                    : null
                  }
                  {(errorUserType !== "")
                      ? <p style={warnStyle}>{errorUserType}</p>
                      : null
                  }
                  {(errorPassword1 !== "")
                      ? <p style={warnStyle}>{errorPassword1}</p>
                      : null
                  }
                  {(errorPassword2 !== "")
                    ? <p style={warnStyle}>{errorPassword2}</p>
                    : null
                  }
                  {(errorPasswordMatch !== "")
                    ? <p style={warnStyle}>{errorPasswordMatch}</p>
                    : null
                  }
                  {(errorPasswordLength !== "")
                    ? <p style={warnStyle}>{errorPasswordLength}</p>
                    : null
                  }
                </div>
              </div>

              <div
                style={{
                  margin: '30px 0 150px 0',
                  display: 'flex',
                  justifyContent: 'center'}}
                  >
                <div 
                  style={
                      hover === true
                      ? buttonStyleTrue
                      : buttonStyleFalse
                  }
                  onClick={(e)=> handleSubmitUser(e)}
                  onMouseEnter={() => setHover(true)}
                  onMouseLeave={() => setHover(false)}
                >
                
                <p style={{margin: '0'}}>
                    Submit
                </p>
            </div>
              </div>
            </form>

          </div>
          <div style={{width: '7vw'}}>
          </div>
        </div>
      </div>
    )
  }




// const dateVar = new Date();
// const dateJoined = (((dateVar.getMonth() > 8) ? (dateVar.getMonth() + 1) : ('0' + (dateVar.getMonth() + 1))) + '/' + ((dateVar.getDate() > 9) ? dateVar.getDate() : ('0' + dateVar.getDate())) + '/' + dateVar.getFullYear());